<template>
  <div class="d-flex align-center justify-space-between mb-3">
    <div class="d-flex flex-column">
      <div class="d-flex align-center ga-1">
        <span class="font-weight-bold d-block font-size-15">Доступи</span>
        <span class="text-disabled font-size-13">
          ({{ journalSource.users?.length }})
        </span>
      </div>
      <span class="text-disabled">
        Користувачі, які можуть реєструвати документи в даному журналі
      </span>
    </div>
    <entity-select-menu
      :selected-items="journalSource.users"
      directory-key="userList"
      @select-item="addUser"></entity-select-menu>
  </div>
  <div v-if="journalSource.users?.length" class="d-flex flex-column ga-2">
    <v-card v-for="user in journalSource.users" :key="user.id" border>
      <v-card-text>
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-center ga-2">
            <v-avatar color="indigo-lighten-5" size="36">
              <v-img v-if="user.photo" :src="user.photo" />
              <span
                v-else
                class="text-indigo-darken-1 font-weight-bold text-caption">
                {{ user.name?.[0] }}{{ user.surname?.[0] }}
              </span>
            </v-avatar>
            <span class="font-size-14">
              {{ getPersonName(user, { initials: true }) }}
            </span>
          </div>
          <v-btn
            :loading="
              $loading.isLoading(`registrationJournalUserDelete_${user.id}`)
            "
            border
            class="text-none"
            size="small"
            style="border-color: #ddd"
            variant="outlined"
            @click="deleteUser(user.id)">
            <span class="font-weight-medium text-error">Видалити</span>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
  <v-card v-else border color="grey-lighten-5">
    <v-card-text class="d-flex justify-center align-center py-8">
      <span class="text-disabled d-block">Немає доданих користувачів</span>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import EntitySelectMenu from '@/components/inputs/EntitySelectMenu.vue'
import { useRegistrationJournal } from '../registrationJournal'
import { confirm, handleAsync, setSnackbar } from 'best-modules/plugins'
import {
  registrationJournalUserCreate,
  registrationJournalUserDelete,
} from '@/requests/registrationJournal'
import { getPersonName } from 'best-modules/utils/helpers'
import { RegistrationJournalUser } from '@/utils/types/registrationJournal'

export default {
  name: 'RegistrationJournalAccesses',
  components: { EntitySelectMenu },
  methods: { getPersonName },
  setup() {
    const { journalSource, journalId } = useRegistrationJournal()

    const addUser = (item: RegistrationJournalUser) => {
      return registrationJournalUserCreate(journalId.value, item.id).then(
        res => {
          journalSource.users = res.users
          setSnackbar({ text: 'Користувача додано до журналу' })
        }
      )
    }

    const deleteUser = (userId: number) => {
      confirm({
        text: 'Ви дійсно бажаєте видалити користувача з доступу до журналу реєстрацій?',
      }).then(() => {
        return handleAsync(`registrationJournalUserDelete_${userId}`, () => {
          return registrationJournalUserDelete(journalId.value, userId).then(
            res => {
              if (res) {
                journalSource.users = res.users
                setSnackbar({ text: 'Користувача видалено з журналу' })
              }
            }
          )
        })
      })
    }

    return {
      addUser,
      deleteUser,
      journalSource,
    }
  },
}
</script>

<style lang="scss" scoped></style>
